// src/pages/message-center/components/PhaseProgressBar.jsx
import React from 'react';
import styles from './PhaseProgressBar.module.css';

const PhaseProgressBar = ({ percentage, colorClass, showLabel = true }) => {
  const width = percentage == null ? 0 : percentage;

  return (
    <div className={styles.progressWrapper}>
      <div className={styles.progressTrack}>
        <div className={`${styles.progressFill} ${styles[colorClass]}`} style={{ width: `${width}%` }} />
      </div>
      {showLabel && (
        <span className={`${styles.progressLabel} ${styles[`label-${colorClass}`]}`}>
          {percentage == null ? '—' : `${percentage.toFixed(1)}%`}
        </span>
      )}
    </div>
  );
};

export default PhaseProgressBar;
